import React, { memo } from 'react';
import classNames from 'classnames';

import { WysiwygView } from '../../helpers/WysiwygView';

/**
 * Component is used to display 1 contact's email.
 *
 * @param props {Object} Any extra props that allowed on <p> tag.
 * @param props.onMouseEnter {Function} OnMouseEnter callback. 1st arg is event. 2nd is deal note's eventId.
 * @param props.onMouseLeave {Function} OnMouseLeave callback. 1st arg is event. 2nd is deal note's eventId.
 * @param props.email {Immutable.Map} Map, that should describe email. #content {string} is note content.
 * #[isMarked=false] {boolean} uf `true` append .text-bold class to element. #eventId is email's eventId.
 */
const ContactExecutiveEmailLogLine = ({ onEditEvent, onMouseEnter, onMouseLeave, email, ...rest }) => {
  const className = classNames({ 'text-bold': email.get('isMarked') });
  const content = email.get('content', '');

  // todo add date display
  return (
    <div
      {...rest}
      className={className}
      onDoubleClick={event => onEditEvent(event, email.set('id', email.get('eventId')))}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <WysiwygView html={content} onDoubleClick={event => onEditEvent(event, email.set('id', email.get('eventId')))} />
    </div>
  );
};

const ContactExecutiveEmailPanel = ({ emails, onEditEvent, onMouseEnter, onMouseLeave }) => {
  const content =
    emails.size === 0 ? (
      <p className="text-center"> No rows to display </p>
    ) : (
      emails.map(email => (
        <ContactExecutiveEmailLogLine
          key={email.get('id')}
          email={email}
          onEditEvent={onEditEvent}
          onMouseEnter={event => onMouseEnter(event, email.get('eventId'))}
          onMouseLeave={event => onMouseLeave(event, email.get('eventId'))}
        />
      ))
    );

  return (
    <div className="panel panel-default">
      <div className="panel-heading" data-parent="#accordion" data-target="#acc-slide-6" data-toggle="collapse">
        <h4 className="panel-title"> Email Log / Buyer Notes </h4>
      </div>
      <div className="panel-collapse collapse" id="acc-slide-6">
        <div className="panel-body">{content}</div>
      </div>
    </div>
  );
};

export default memo(ContactExecutiveEmailPanel);
